import React, { useState } from "react";
import { useSelector } from "react-redux";
import Name from "./Name.js";
import Phone from "./Phone.js";
import Email from "./Email.js";
import Password from "./Password.js";
import {word} from '../../../word.js'
const Settings = ({ close }) => {
    const [show, setShow] = useState(""); // Local state for managing modal visibility

    const login = useSelector((state) => state.manager.employee);

    return (
        <div className="settings-cont">
            {show === "password" && <div className="popup" onClick={() => setShow("")}/>}
            {show === "password" && <Password close={() => setShow("")} />}

            <div className="settings">
                <i className="fa fa-times" aria-hidden="true" onClick={close}/>

                {/* First Name */}
                <div>
                    <div className="settings-elem">
                        <span className="label">Անուն</span>
                        <span className="data">{login.user.first_name}</span>
                        <div className="tool-tip-cont">
                            <div className="tool-tip">Խմբագրել</div>
                            <span onClick={() => setShow("name")} className="icon-Compose"/>
                        </div>
                    </div>
                    {show === "name" && <Name close={() => setShow("")} />}
                </div>

                {/* Last Name */}
                <div>
                    <div className="settings-elem">
                        <span className="label">{word.surname}</span>
                        <span className="data">{login.user.last_name}</span>
                        <div className="tool-tip-cont">
                            <div className="tool-tip">Խմբագրել</div>
                            <span onClick={() => setShow("surname")} className="icon-Compose"/>
                        </div>
                    </div>
                    {show === "surname" && <Name close={() => setShow("")} showSettings="surname" />}
                </div>

                {/* Phone Number */}
                <div>
                    <div className="settings-elem">
                        <span className="label">{word.phone}</span>
                        <span className="data">{login.phone}</span>
                        <div className="tool-tip-cont">
                            <div className="tool-tip">Խմբագրել</div>
                            <span onClick={() => setShow("phone")} className="icon-Compose"/>
                        </div>
                    </div>
                    {show === "phone" && <Phone close={() => setShow("")} />}
                </div>

                {/* Email */}
                <div>
                    <div className="settings-elem">
                        <span className="label">{word.email}</span>
                        <span className="data">{login.user.email}</span>
                        <div className="tool-tip-cont">
                            <div className="tool-tip">Խմբագրել</div>
                            <span onClick={() => setShow("email")} className="icon-Compose"/>
                        </div>
                    </div>
                    {show === "email" && <Email close={() => setShow("")} />}
                </div>

                {/* Password */}
                <div className="settings-elem">
                    <span>{word.password}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Խմբագրել</div>
                        <span onClick={() => setShow("password")} className="icon-Compose"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
